export default __webpack_public_path__ + "static/hero-e849182d70721839e094977e67c5cb78.png";